import { useEffect, useState } from 'react';
import { applyEmbedTheme, readEmbedThemeMessage, resolveEmbedTheme } from '../theme/embedTheme';

export const useEmbedTheme = () => {
  const [embedTheme, setEmbedTheme] = useState(resolveEmbedTheme);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const nextTheme = readEmbedThemeMessage(event);
      if (!nextTheme) return;
      applyEmbedTheme(nextTheme);
      setEmbedTheme(nextTheme);
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return embedTheme;
};
